// import { useEffect, useRef } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { t } from 'i18next';
import { ArrowLeft } from '@peacecover/icon';
import { useBettieBalancesTransactions } from './hooks/useBettieBalancesTransactions';
// import { useAdMob } from './hooks/useAdMob';
import { useHandleHistoryBack } from '../../utils/useHandleHistoryBack';
import RefundExchangeNotice from './components/RefundExchangeNotice';
import BettieTransactionItem from './components/BettieTransactionItem';
import EmptyCaseWithTicketImage from './components/EmptyCaseWithTicketImage';

const BettieUsagePage = () => {
  const handleHistoryBack = useHandleHistoryBack();
  const { totalBettieBalance, bettieTransactions, isLoading, loadMore } =
    useBettieBalancesTransactions();

  // const { isAdReady, showAd } = useAdMob({
  //   autoLoad: true,
  //   featureKind: 'interstitial',
  //   adType: 'interstitial',
  //   onReward: (data) => {
  //     console.log('보상 받음:', data);
  //   },
  //   onError: (errorMsg) => {
  //     console.error('광고 에러:', errorMsg);
  //   }
  // });

  // const hasShownRef = useRef(false);

  // useEffect(() => {
  //   if (isAdReady && !hasShownRef.current) {
  //     hasShownRef.current = true;
  //     showAd();
  //   }
  // }, [isAdReady, showAd]);

  return (
    <div className="min-h-screen pt-[calc(env(safe-area-inset-top))] pb-[calc(env(safe-area-inset-bottom)+32px)]">
      <div className="sticky top-0 grid grid-cols-3 items-center px-[16px] py-[10px] bg-background-light dark:bg-background-dark">
        <ArrowLeft
          size={24}
          className="text-text-main-lv1 justify-self-start"
          onClick={handleHistoryBack}
        />
        <p className="col-start-2 text-[17px] font-bold text-text-main-lv1 leading-[20px] text-center">
          {t('BettieUsage.title')}
        </p>
      </div>
      <div className="w-full">
        {isLoading ? (
          <BettieTransactionListSkeleton />
        ) : bettieTransactions.length === 0 ? (
          <EmptyCaseWithTicketImage
            title={t('BettieUsage.emptyCaseTitle')}
            className="mt-[196px]"
          />
        ) : (
          <div className="flex flex-col items-center px-[24px] mt-[17px]">
            <div className="flex flex-col items-start gap-[8px] w-full">
              <p className="text-[16px] font-medium text-text-main-lv2 leading-[19px]">
                {t('BettieUsage.leftChatCount')}
              </p>
              <p className="text-[20px] font-semibold text-text-main-lv2 leading-[24px]">
                {t('BettieUsage.totalCount', { count: totalBettieBalance })}
              </p>
            </div>
            <hr className="w-full border-surface-lv2 mt-[18px]" />
            {(() => {
              const flatList = bettieTransactions.flatMap(([dateLabel, items]) => [
                { type: 'header' as const, dateLabel },
                ...items.map((item) => ({ type: 'item' as const, item }))
              ]);
              return (
                <div className="w-full">
                  <Virtuoso
                    useWindowScroll
                    style={{ width: '100%' }}
                    totalCount={flatList.length}
                    itemContent={(index) => {
                      const entry = flatList[index];
                      if (entry.type === 'header') {
                        return (
                          <div className="w-full pt-[20px] pb-[4px] text-[13px] text-text-main-lv4 leading-[16px]">
                            {entry.dateLabel}
                          </div>
                        );
                      }
                      return (
                        <BettieTransactionItem key={entry.item.transactionId} item={entry.item} />
                      );
                    }}
                    endReached={loadMore}
                  />
                </div>
              );
            })()}
          </div>
        )}
        <RefundExchangeNotice
          className={`${bettieTransactions.length > 0 ? 'mt-[70px]' : 'mt-[324px]'}`}
        />
      </div>
    </div>
  );
};

export default BettieUsagePage;

const BettieTransactionListSkeleton = () => {
  return (
    <div className="flex flex-col items-center px-[24px] mt-[17px]">
      <div className="flex flex-col items-start gap-[8px] w-full">
        <p className="text-[16px] font-medium text-text-main-lv2 leading-[19px]">
          {t('BettieUsage.leftChatCount')}
        </p>
        <p className="text-[20px] font-semibold text-text-main-lv2 leading-[24px]">
          {t('BettieUsage.totalCount', { count: 0 })}
        </p>
      </div>
      <hr className="w-full border-surface-lv2 mt-[18px]" />
      <div className="w-full animate-pulse">
        <div className="w-[70px] h-[16px] mt-[20px] mb-[4px] rounded-full bg-gray-100 dark:bg-gray-800" />
        {Array.from({ length: 5 }).map((_, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton
          <div key={index} className="w-full">
            <div className="w-full flex items-center justify-between py-[16px]">
              <div className="flex items-center gap-[12px] min-w-0 flex-1">
                <div className="flex flex-col gap-[6px] min-w-0 flex-1">
                  <div className="h-[19px] w-[50px] rounded-full bg-gray-100 dark:bg-gray-800" />
                  <div className="h-[16px] w-[100px] rounded-full bg-gray-100 dark:bg-gray-800" />
                </div>
              </div>
              <div className="flex flex-col items-end gap-[4px] flex-shrink-0">
                <div className="h-[19px] w-[50px] rounded-full bg-gray-100 dark:bg-gray-800" />
                <div className="h-[16px] w-[40px] rounded-full bg-gray-100 dark:bg-gray-800" />
              </div>
            </div>
            <hr className="w-full border-surface-lv2" />
          </div>
        ))}
      </div>
    </div>
  );
};
